<template>
  <div>
    <vue-headful title />
    <Header :link="{ name: 'job_step-2' }" />
    <div id="job-review" class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-1 mb-2">
        <h1 class="heading-title">{{ job.title }}</h1>
        <label class="text text-gray m-0 m-0">Type vacature</label>
        <p>
          <strong>{{ profession }}</strong>
        </p>
        <label class="text text-gray m-0 m-0">Opleidingsniveau</label>
        <p>
          <strong>{{ degree }}</strong>
        </p>
        <label class="text text-gray m-0 m-0">Begin datum</label>
        <p>
          <strong>{{ job.start_date | moment("D MMMM YYYY") }}</strong>
        </p>
        <div class="pt-1">
          <p class="br">{{ job.description }}</p>
        </div>
        <div class="pt-4 pb-3">
          <div class="clearfix">
            <p class="float-left">Voorbeeld vacature</p>
            <p class="float-right">(3/3)</p>
          </div>
          <div class="progress mb-4">
            <div
              class="progress-bar bg-warning"
              role="progressbar"
              style="width: 100%"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <button
          type="button"
          @click="onSubmit"
          class="btn btn-warning btn-block"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
        >
          Plaats vacature
        </button>
      </div>
    </div>
    <div class="fullscreen-notif position-fixed" v-show="success">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <p>
              Gefeliciteerd!
              <br />je vacature is geplaatst.
            </p>
            <p>Je ontvangt bericht wanneer de perfecte match is gevonden!</p>
          </div>
          <router-link
            :to="{ name: 'company-dashboard' }"
            class="btn btn-secondary btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Naar je dashboard</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      job: {},
      profession: null,
      degree: null,
      success: false
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.job = JSON.parse(localStorage.getItem("job"));
      this.profession = await this.getAPIList(
        "professions",
        this.job.profession_id
      );
      this.degree = await this.getAPIList("degrees", this.job.degree_id);
      this.$store.state.loading = false;
    },
    async saveJob() {
      // console.log("async saveJob()");
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/job";
        let formData = new FormData();
        for (var obj in this.job) {
          formData.append(obj, this.job[obj]);
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("job");
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async onSubmit() {
      // console.log("async onSubmit()");
      this.$store.state.loading = true;
      await this.saveJob();
      this.$store.state.loading = false;
      this.success = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    // remove the form-pending if accessing sub page
    var subpages = ["job_step-2"];
    if (subpages.indexOf(to.name) > -1) {
      next();
    } else {
      this.savePending(to, from, next);
    }
  }
};
</script>

<style scoped></style>
